import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import HeaderMenu from "./sidebar/headermenu";
import Story from "./story";
import RightWrap from "./rightside/right_wrap";
import EventWrap from "./events/event_wrap";
import { API_STATUS } from "../constants";
import { GetActiveUser } from "../apis/user/get_active_user";
import { reloadState } from "../redux/GlobalSlice";
import SavedEventWrap from "./events/saved_event_wrap";
import { GetUserSpace } from "../apis/user/get_user_space";

export default function ManageStorage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const globalState = useSelector(state => state.globalstate);

    const [userApi, setUserApi] = useState(API_STATUS);
    const [getUsed, setUsed] = useState(API_STATUS);
    const [activeUser, setActiveUser] = useState('');
    const [storage, setStorage] = useState('');
    const [pImg, setPimg] = useState('0');
    const [pVideo, setPvideo] = useState('0');
    const [port, setPort] = useState('0');
    const [space, setSpace] = useState(0);
    const [spaceUsed, setSpaceUsed] = useState(0);
    const [balBar, setBalbar] = useState(0.0);


    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        }
        const user = JSON.parse(sessionStorage.getItem('LOGIN_DATA'));
        if (user.userType == 1) {
            navigate('/');
        }
        if (user.space != 'Unlimited') {
            //console.log(((res.data.space_bal / res.data.space) * 300).toFixed(1));
            setSpace((user.space / 1024).toFixed(1));
            setSpaceUsed((user.space_bal / 1024).toFixed(1));
            let bb = ((user.space_bal / user.space) * 400).toFixed();
            setBalbar(parseInt(bb));
        } else {
            setSpace(user.space);
        }
        setActiveUser(user);

        GetUserSpace(setUsed);
    }, []);


    useEffect(() => {
        if (storage !== '') {
            if (storage.post.length > 0) {
                storage.post.forEach((item, i) => {
                    if (item.f_type == 'image') {
                        setPimg(item.size);
                    }
                    if (item.f_type == 'video') {
                        setPvideo(item.size);
                    }
                });
            }
            if (storage.portfolio.size !== null) {
                setPort(storage.portfolio.size);
            }
        }
    }, [storage]);

    useEffect(() => {
        if (!getUsed.isLoader && !getUsed.isError && getUsed.data != null) {
            let res = getUsed.data;
            if (res['status'] === 1) {
                setStorage(res.data[0]);
            }
        }
    }, [getUsed]);


    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">
            <div className="">
                <div className="main__inner">
                    <div className="page__heading py-2 md:py-6 mt-2 md:mt-6">
                        <h2 className="text-lg font-bold"> Manage Storage </h2>
                    </div>
                    {/* <div onClick={ulogout}>Logout</div> */}
                    <div className="flex max-lg:flex-col xl:gap-10 md:gap-3 md:mt-10" id="js-oversized">
                        <div className="md:max-w-[510px] mx-auto flex-1 xl:space-y-6 space-y-3">
                            <div className="bg-white rounded-xl p-5 px-6 shadow-sm border1 dark:bg-dark2">
                                <div className="text-[17px]">Manage your storage with filmwings</div>
                                <div className="mt-5" style={{ width: 400 }}>
                                    <div className="flex justify-between">
                                        <div className="text-[15px]">{spaceUsed} MB Left</div>
                                        <div className="text-[15px]">{space} MB Total</div>
                                    </div>
                                    <div style={{ width: 400, backgroundColor: '#d1d1d1', height: 5 }}>
                                        <div style={{ width: balBar, backgroundColor: '#05afe9', height: 5 }}></div>
                                    </div>
                                </div>

                                <div className="mt-5" style={{ width: 400, alignItems: 'center' }}>
                                    <div className="flex justify-between py-2" style={{ borderBottom: 'solid 1px #ddd' }}>
                                        <div className="text-[15px]">Post Images</div>
                                        <div className="text-[15px]">{pImg != '0' ? (pImg / 1024).toFixed(1) : '0'} MB</div>
                                    </div>
                                    <div className="flex justify-between py-2" style={{ borderBottom: 'solid 1px #ddd' }}>
                                        <div className="text-[15px]">Post Videos</div>
                                        <div className="text-[15px]">{pVideo != '0' ? (pVideo / 1024).toFixed(1) : '0'} MB</div>
                                    </div>
                                    <div className="flex justify-between py-2" style={{ borderBottom: 'solid 1px #ddd' }}>
                                        <div className="text-[15px]">Portfolio Images/Videos</div>
                                        <div className="text-[15px]">{port != '0' ? (port / 1024).toFixed(1) : '0'} MB</div>
                                    </div>

                                    <div className="text-center mt-5">
                                        {
                                            activeUser['subId'] === null &&
                                            <button onClick={() => {
                                                navigate('/create_artist_profile', { state: { userData: activeUser } });
                                            }} className="button bg-pink-100 text-pink-600 border border-pink-200">Create Portfolio</button>
                                        }
                                        {
                                            activeUser['subId'] != null && activeUser['subPayStatus'] == 0 &&
                                            <button onClick={() => {
                                                navigate('/sub_payment/' + activeUser['subId']);
                                            }} className="button bg-pink-100 text-pink-600 border border-pink-200">Upgrade Plan</button>
                                        }
                                        {
                                            activeUser['subId'] != null && activeUser['subPayStatus'] == 1 &&
                                            <button onClick={() => {
                                                navigate('/purchase_space');
                                            }} className="button bg-pink-100 text-pink-600 border border-pink-200">Upgrade Plan</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <RightWrap />
                    </div>
                </div>
            </div>
        </main>
    </div>
}